module.exports = __webpack_public_path__ + "static/media/cny-set-2023-1.7b2fbb76.gif";